export default {
  // Wage
  SET_WAGE_DATA: (state, data) => state.wageData = data,
  // Medical staff
  SET_MEDICAL_STAFF: (state, data) => state.medicalStaff = data,
}
